<template>
  <div class="token" style="text-align: justify">
    <h2 style="margin-bottom: 10px; margin-top: 45px">Choose a Token</h2>

    <el-select
      style="width: 100%; margin-bottom: 10px"
      v-model="message"
      @change="setInfo()"
    >
      <el-option
        v-for="option in options"
        v-bind:value="
          option.text + '|' + option.num + '|' + option.token + '|' + option.url
        "
        :label="option.label"
      >
      </el-option>
    </el-select>
    <br />
    <span>
      {{ info }}
    </span>
    <h2 style="margin-bottom: 10px; margin-top: 45px">Amount</h2>
    <div>
      <el-input disabled :placeholder="num" />
    </div>
    <h2 style="margin-bottom: 10px; margin-top: 45px">Address</h2>
    <el-input
      v-model="address"
      placeholder="Please enter your BitTorrent Chain Donau address starting with 0x."
    ></el-input>
    <el-button
      style="width: 100%; margin-top: 50px"
      type="primary"
      :disabled="!address"
      @click="onSubmitBefore"
      >Obtain</el-button
    >
    <br />
    <ol style="padding-left: 20px; margin-top: 100px">
      <div style="margin-left: -16px">Note:</div>
      <li>Testnet tokens are available once a day per address per token.</li>
      <li>
        Each IP address is allowed to acquire testnet tokens for at most 20
        times per day.
      </li>
    </ol>
    <recaptcha v-if="isModalOpen" @changeResponse="handleChangeResponse" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import Recaptcha from './Recaptcha.vue'
import axios from "axios";
export default {
  components: {
    Recaptcha,
  },
  data() {
    return {
      info: "BTT is used to pay fees during transactions on BitTorrent Chain Donau.",
      num: "1,000,000",
      token: "btt",
      url: "",
      address: "",
      message:
        "BTT is used to pay fees during transactions on BitTorrent Chain Donau.|1,000,000|btt|",
      options: [
        {
          text: "BTT is used to pay fees during transactions on BitTorrent Chain Donau.",
          num: "1,000,000",
          token: "btt",
          label: "BTT(BitTorrent）",
          url: "",
        },
      ],
      isModalOpen: false,
      response: '',
    };
  },
  methods: {
    setInfo() {
      this.info = this.message.split("|")[0];
      this.num = this.message.split("|")[1];
      this.token = this.message.split("|")[2];
      this.url = this.message.split("|")[3];
    },
    closeDialog() {
      this.isModalOpen = false
    },
    onSubmitBefore() {
      this.isModalOpen = true
    },
    handleChangeResponse(val) {
      this.response = val
      console.log('response', this.response)
      this.isModalOpen = false
      this.onSubmit()
    },
    onSubmit() {
      axios
        .get("/transferbttc?address=" + this.address + "&token=" + this.token, {
          headers: {'X-Response': this.response}
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 0) {
            return this.$notify({
              title: "Sucess",
              message: "Sent successfully",
              type: "success",
            });
          } else if (res.data.status == 2) {
            return this.$notify({
              title: "Error",
              message: "Address error",
              type: "error",
            });
          } else if (res.data.status == 3) {
            return this.$notify({
              title: "Error",
              message: "Obtained once a day",
              type: "error",
            });
          } else {
            return this.$notify({
              title: 'Error',
              message: res.data?.msg || 'Too many requests',
              type: 'error',
            });
          }
        })
        .catch((err) => {
          //捕获异常状态码
          console.log(err);
          return this.$notify({
            title: "Error",
            message: "Too many requests",
            type: "error",
          });
        });
    },
  },
};
</script>
